import { API_URL } from "@/config/constants";
import axios from "axios";
import {
    ILibraryFolder,
    ILibraryFolderCreate,
    ILibraryFolderListResponse,
    ILibraryFolderMinimal,
    ILibraryFolderMoveRequest,
    ILibraryFolderUpdate,
} from "./library-folders.types";

const API = `${API_URL}/library/folders`;

export const getLibraryFolders = async (
    options: { includeShared?: boolean } = {}
) => {
    const result = await axios.get<ILibraryFolderListResponse>(API, {
        ...(options.includeShared === true
            ? { params: { include_shared: true } }
            : {}),
    });
    return result.data;
};

export const searchLibraryFolders = async (q: string) => {
    const result = await axios.get<ILibraryFolder[]>(`${API}/search`, {
        params: { q },
    });
    return result.data;
};

export const getLibraryFoldersMinimal = async () => {
    const result = await axios.get<ILibraryFolderMinimal[]>(`${API}/minimal`);
    return result.data;
};

export const createLibraryFolder = async (data: ILibraryFolderCreate) => {
    const result = await axios.post<ILibraryFolder>(API, data);
    return result.data;
};

export const updateLibraryFolder = async (
    id: number,
    data: ILibraryFolderUpdate
) => {
    const result = await axios.put<ILibraryFolder>(`${API}/${id}`, data);
    return result.data;
};

export const deleteLibraryFolder = async (
    id: number,
    moveToFolderId?: number
) => {
    const params = moveToFolderId ? { move_to_folder_id: moveToFolderId } : {};
    await axios.delete(`${API}/${id}`, { params });
};

export const moveLibraryFolder = async (
    id: number,
    data: ILibraryFolderMoveRequest
) => {
    const result = await axios.put<ILibraryFolder>(`${API}/${id}/move`, data);
    return result.data;
};
